export var DropdownPosition = {
  right: 'right',
  left: 'left'
};

export var DropdownDirection = {
  up: 'up',
  down: 'down'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Dropdown/dropdownConstants.js
// module id = 67
// module chunks = 0